/**
 * Add subscribe/unsubscribe to the NicheListWidget.
 */

import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { showAuthModal } from "store/application/application-action";
import { useMyNichesQuery } from "queries";
import { INiche } from "services/types";
import { apiNiches } from "services";
import { useVisitorInfo } from "hooks";

import { INicheInfo, NicheListWidget } from "./NicheListWidget";

export const NicheListWidgetAlive = (props: {
  title: string;
  link: string;
  className?: string;
  niches: INicheInfo[];
  page: number;
}): JSX.Element => {
  const [following, setFollowing] = useState<string[]>([]);
  const [niches, setNiches] = useState<INicheInfo[]>([]);
  const dispatch = useDispatch();

  const { data: { niches: followedNiches = [] } = {} } = useMyNichesQuery({
    previews: false,
  });

  const me = useVisitorInfo();

  useEffect(() => {
    if (followedNiches.length) {
      const ids = followedNiches.map((niche: INiche): string => niche.id);
      setFollowing(ids);
    }
  }, [followedNiches]);

  useEffect(() => {
    const nichesList = props.niches.map((n: INicheInfo): INicheInfo => ({
      ...n,
      following: following.indexOf(n.id) >= 0,
    }));

    setNiches(nichesList);
  }, [props.niches, following]);

  const onFollow = async (id: string, follow: boolean) => {
    if (me === null) {
      dispatch(showAuthModal());
    } else {
      follow ? await followNiche(id) : await unfollowNiche(id);
    }
  };

  const followNiche = async (id: string) => {
    setFollowing((prev) => [...prev, id]);
    await apiNiches.follow(id);
  };

  const unfollowNiche = async (id: string) => {
    setFollowing((prev) => prev.filter((x) => x !== id));
    await apiNiches.unfollow(id);
  };

  return (
    <NicheListWidget
      title={props.title}
      link={props.link}
      className={props.className}
      niches={niches}
      onFollow={onFollow}
      page={props.page}
    />
  );
};
